// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__Wgihi","banner__inner":"Banner_banner__inner__9QU1u","banner__text":"Banner_banner__text__aO+sn"};